import React from "react";
import SensorBase from "./SensorBase";

const FIELD = "airTemp";
const UNIT = "°C";

const AirTemperature: React.FC = () => {
  return (
    <SensorBase field={FIELD} unit={UNIT}></SensorBase>
  );
};

export default AirTemperature;
